<script>
  import { store, ContactsForm, MediaSlider, PartnersSlider, Button } from '$client';
  const { other } = store;
  export let data;
  $: page = data.partneramPage;
</script>

<section id="main">
  <section class="container">
    <div>
      <div>
        <h1 class="h1">{@html page.header}</h1>
        <p>{@html page.description}</p>
      </div>
      <img height="214" width="285" src="https://admin.uberi.pro/uploads/eco_c56dbe0dde.webp" alt={page.header} />
    </div>
    {#if page.button[0]}
      <Button action={page.button[0].href ?? page.button[0].modal} title={page.button[0].header} />
    {/if}
  </section>
  <PartnersSlider data={$other.partners.data} />
  <ContactsForm data={page.form.data.attributes} />
  <MediaSlider type="white" header="Последние события" data={data.medias} />
</section>

<style lang="scss">
  #main {
    display: flex;
    flex-direction: column;
    gap: 80px;
    margin-block: 50px;

    :global(.slider-container) {
      padding-block: 0 !important;
    }

    @media only screen and (max-width: 767.98px) {
      gap: 50px;
      margin-block: 30px;
    }
  }

  div > div {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;

    h1 {
      color: #2c333c;
      font-weight: 800;
      font-family:
        Vela Sans,
        sans-serif;
    }

    p {
      margin-bottom: 40px;
      color: #2c333c;
      font-size: 18px;
      font-family: Roboto, sans-serif;
      line-height: 140%;

      :global(br) {
        @media only screen and (max-width: 1200px) {
          display: none;
        }
      }

      @media only screen and (max-width: 1200px) {
        font-size: 17px;
      }

      @media only screen and (max-width: 991.98px) {
        font-size: 16px;
      }
    }
  }

  .container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;

    @media only screen and (max-width: 575.98px) {
      align-items: center;
    }

    > div {
      display: flex;
      gap: 130px;
      align-items: center;
      justify-content: space-between;

      @media only screen and (max-width: 991.98px) {
        gap: 30px;
      }

      img {
        width: 285px;

        @media only screen and (max-width: 991.98px) {
          display: none;
        }
      }
    }
  }
</style>
